import Vue from 'vue';
import App from './App.vue';
import router from './router';
import moment from 'moment';
import Vuetify from 'vuetify';
import it from "vuetify/src/locale/it.ts";
import {checkNotifiche} from "./utils/notifiche.js";
// GESTIONE PLUGIN
import {
  store
} from './store';
import {
  auth
} from './plugins/firebase';

// import plugin
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles 
import 'vuetify/dist/vuetify.min.css'


// Vuetify Object (as described in the Vuetify 2 documentation)
const vuetify = new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#607d8b",
        secondary: "#03a9f4",
        accent: "#8bc34a",
        error: "#ff5722",
        warning: "#ffc107",
        info: "#00bcd4",
        success: "#cddc39",
      },
      light: {
        primary: "#2196f3",
        secondary: "#FB8C00",
        accent: "#00bcd4",
        error: "#ff5722",
        warning: "#ff9800",
        info: "#e91e63",
        success: "#8bc34a",
      },
    },
  },
  lang: {
    locales: { it },
    current: "it",
  },
  icons: {
    iconfont: "fa",
  },
})

// use Vuetify's plugin
Vue.use(Vuetify)
// use this package's plugin
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})
//PLUGIN GRAFICI
import ECharts from 'vue-echarts';
Vue.component('v-chart', ECharts);
// Network
import Network from '@/classes/Global/Networking/Network.js'
Vue.prototype.$network = Network;

// SSEController
/*import SSEController from '@/components/COMMON/SSEController.js';
const sse_controller = new SSEController();
Vue.prototype.$SSEController = sse_controller;
if (localStorage.user_token){
  sse_controller.connect(localStorage.user_token);
}*/
  
// Versione generica del metodo di logout
Vue.prototype.$logout = function () {
  const data_versione = localStorage.data_versione;
  localStorage.clear();
  localStorage.data_versione = data_versione;
  //sse_controller.disconnect();
};

Vue.prototype.$handleError = function (data) {
  if (document.getElementById("inspire")) {
    // Se esiste la pagina di login...
    const evento = new CustomEvent("error_api", {
      detail: data,
    });
    document.getElementById("inspire").dispatchEvent(evento);
  } else if (document.getElementById("inspire_main")) {
    // Se esiste la barra della home...
    const evento = new CustomEvent("error_api", { detail: data });
    document.getElementById("inspire_main").dispatchEvent(evento);
    console.log("api errore:", data);
  }
};
Vue.prototype.$handleUnauthorized = function () {
  if (document.getElementById("inspire")) {
    // Se esiste la pagina di login...
    const evento = new CustomEvent("not_allowed", {
      detail: null,
    });
    document.getElementById("inspire").dispatchEvent(evento);
  } else if (document.getElementById("inspire_main")) {
    // Se esiste la barra della home...
    const evento = new CustomEvent("relog", { detail: null });
    document.getElementById("inspire_main").dispatchEvent(evento);
  }
};

store.$logout = Vue.prototype.$logout;

store.$handleError = Vue.prototype.$handleError;

store.$handleUnauthorized = Vue.prototype.$handleUnauthorized;

// GESTIONE WORKER
import {
  jWorkers
} from '@/components/COMMON/JWorkers.js';
Vue.prototype.$worker = jWorkers;

//PLUGIN GRAFICA
// import vuetify from './plugins/vuetify';
//PLUGIN QUERY SU DATA ARRAY
import alasqlJs from '../node_modules/alasql/dist/alasql.min.js';
//PLUGIN ZOOM CHAT
import VueZoomer from 'vue-zoomer';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import * as VueGoogleMaps from 'vue2-google-maps';

import axios from "axios";
import DatetimePicker from 'vuetify-datetime-picker'
import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(DatetimePicker)
Vue.use(VueQrcodeReader);

Vue.use(VueZoomer);
Vue.use(Viewer)

import vueXlsxTable from 'vue-xlsx-table';
Vue.use(vueXlsxTable, {
  rABS: false
});


//SCARICARE DATI IN FOGLI EXCEL, PER QUICKCHECK
import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);

//BARRA PER IL CARICAMENTO
import VueProgressBar from 'vue-progressbar';
const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'left',
  inverse: false,
};

Vue.use(VueProgressBar, options);

Vue.component('google-map', VueGoogleMaps.Map)
Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  installComponents: true,
  load: {
    key: 'AIzaSyBNH-zPacFsPV5MlWmr0E6FO_0tontcBp0',
    libraries: 'places',
    autobindAllEvents: true
  }
});

Vue.config.productionTip = false;
const alasql = {
  install() {
    Vue.prototype.alasql = alasqlJs;
  },
};
Vue.use(alasql);
Vue.use(moment);
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
});
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM HH:mm');
  }
});
Vue.filter('timestampToHour', function (value) {
  if (value) {
    var date = new Date(parseInt(value));
    return moment(String(date)).format('DD/MM HH:mm');
  }
});
// new Vue({
//   router,
//   store,
//   vuetify,
//   render: (h) => h(App),
// }).$mount("#app");
let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      auth,
      watch: {
        '$route': function(to, from) {
          checkNotifiche(to, from);
        }
      },
      data() {
        return {
          ready: false,
        };
      },
      async beforeCreate() {
        // await this.$store.commit("setInfo", {
        //   config
        // });
        await new Promise((resolve, reject) => {
          axios
            .get("../../../config.json")
            .then((response) => {
              this.$store.commit("setInfo", response.data);
              resolve(response);
              return;
            })
            .catch((e) => {
              reject(e);
              console.log(e);
            });
        });


        // await this.$store.dispatch('getInfo');
        this.$mount('#app');
      },
      render: (h) => h(App),
    });
  }
});